export class SearchResultBase {
  results: SearchResult[];
  searchText: string;
  totalResults: number = 0;
  countByMarketIds: {[key: string]: number};
  countByProdCategories: {[key: string]: number};
}

export class SearchResult {
  id: string;
  index: 'product' | 'bom' | 'worksheet' | 'account_details' | 'project';
  type: string;
  score: number;
  highlights: Map<string, string[]>;

  /* Product */
  productTesscoId: number;
  productId: string;
  productName: string;
  productTesscoPartNumber: string;
  productDescription: string;
  productSummary: string;
  productManufacturerName: string;
  productManufacturerPartNumber: string;
  productUpc: string;
  productUnitOfMeasure: string;
  productSellingRestrictionCode: string;
  productIsGsa: boolean;
  productPurchasePlanIds: string[];
  productCreationDate: Date;
  productCategory: string;
  productConsignmentAccountNos: string[];
  productNumberOfTimesOrdered: number;
  //Used only in UI
  productImage: string;
  productListPrice: number;

  /* Master Bom */
  bomId: string;
  bomName: string;
  bomNotes: string;
  bomType: number;
  bomCreatedDate: Date;
  bomMarketIds: string[];
  bomActive: boolean;

  /* Worksheet */
  worksheetId: string;
  worksheetName: string;
  worksheetApprovalStatus: 'PENDING' | 'APPROVED' | 'DENIED' | 'DENIED_BY_TESSCO' | 'TESSCO_REVIEW' | 'QUOTED_AWAITING_PO';
  worksheetProjectId: string;
  worksheetProjectName: string;
  worksheetCreatedDate: Date;
  worksheetMarketId: string;
  worksheetOrgId: string;
  worksheetIsQuoted: boolean;
  worksheetOrderNumber: string;
  worksheetIsDeleted: boolean;

  /* Project */
  projectId: string;
  projectName: string;
  projectSummary: string;
  projectCreatedDate: Date;
  projectDeliveryDate: Date;
  projectValue: number;
  projectIcon: string;
  projectMarketId: string;
  projectOrgId: string;
  projectActive: boolean;
  //Used only in UI
  projectMarketName: string;

  /* Account Details */
  accountDetailsId: string;
  accountDetailsAccountNo: string;
  accountDetailsProductRestrictionCodes: string[];

  /* For Expand and Collapse */
  showWorksheetInfo: boolean = false;
}

export class SearchInput {
  searchText: string;
  accountNo: string;
  orgId: string;
  pageNumber: number;
  pageSize: number;
  filterIndexNames: string[];
  filterMarketIds: string[];
  filterProductCategories: string[];
  sortBy: string;

  constructor(searchText: string, accountNo: string, pageNumber: number, pageSize: number, orgId?: string) {
      this.searchText = searchText;
      this.accountNo = accountNo;
      this.orgId = orgId;
      this.pageNumber = pageNumber;
      this.pageSize = pageSize;
      this.orgId = orgId;
  }

  setFilterIndexNames(fin: string[]) {
    this.filterIndexNames = fin;
  }

  setFilterMarketIds(fmi: string[]) {
    this.filterMarketIds = fmi;
  }

  setFilterProductCategories(fpc: string[]) {
    this.filterProductCategories = fpc;
  }

  addToFilterMarketIds(marketId: string) {
    if (!this.filterMarketIds) {
      this.filterMarketIds = [];
    }

    if (!this.filterMarketIds.includes(marketId)) {
      this.filterMarketIds.push(marketId);
    }
  }

  setSortBy(sortBy: string) {
    this.sortBy = sortBy;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/search-result.ts